import { useIntl } from 'react-intl'
import BaseTransportSummary from './BaseTransportSummary'

import type { BusItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: BusItem
}

function BusItemSummary(props: Props) {
  const intl = useIntl()
  return <BaseTransportSummary
    transportName={intl.formatMessage({
      id: 'exdlo0BNmSi4yVcqWO8c',
      defaultMessage: 'Bus',
      description: 'Transport type name for bus used in trip item summary heading',
    })}
    {...props}
  />
}

export default BusItemSummary
